<template>
  <el-table :data="tableData" :empty-text="$t('generic.noData')" show-summary :summary-method="getJourneysTableTotal">
    <el-table-column type="expand">
      <template slot-scope="props">
        <journey-details :details="props.row"/>
      </template>
    </el-table-column>
    <el-table-column
      v-for="column in tableColumns"
      :key="column.label"
      :min-width="column.minWidth"
      :prop="column.prop"
      :label="$t(column.label)"
      :formatter="column.formatter"
    >
    </el-table-column>

    <el-table-column width="50">
      <div slot-scope="{ row }">
        <router-link
          :to="{name: 'account-journey-details', params: {id: row.account_id, journey_id: row.id.String}}">
          <i class="tim-icons icon-double-right"></i>
        </router-link>
      </div>
    </el-table-column>
  </el-table>
</template>
<script>
import {Table, TableColumn} from 'element-ui';
import JourneyDetails from './JourneyDetails'

export default {
  name: 'journeysTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    JourneyDetails
  },
  props: {
    tableData: {
      type: Array,
      required: true,
    },
  },

  methods: {
    getJourneysTableTotal(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = this.$t('journey.table.totalColumn');
          return;
        }
        if (index === 8) {
          let values;
          values = data.map(item => Number(item.charge));

          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
          }

            sums[index] = this.$options.filters['money'](sums[index])
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
  },
  data() {
    return {
      tableColumns: [
        {
          prop: 'operation_ts',
          label: 'journey.details.operation_ts',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.time(cellValue)
          },
        },
        {
          prop: 'journey_type',
          label: 'journey.details.journey_type',
        },
        {
          prop: 'discount_id',
          label: 'journey.details.discount_id',
        },
        {
          prop: 'route',
          label: 'journey.details.route',
        },
        {
          prop: 'schedule',
          label: 'journey.details.schedule',
        },
        {
          prop: 'mapping_id',
          label: 'journey.details.mapping_id',
        },
        {
          prop: 'garage_number',
          label: 'journey.details.garage_number',
        },
        {
          prop: 'charge',
          label: 'journey.details.charge',
          formatter: (row, column, cellValue, index) => {
            return this.$options.filters.price(cellValue)
          },
        }
      ]
    }
  }
};
</script>
<style scoped>
</style>
